import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response, Jsonp, URLSearchParams } from '@angular/http';
// import { User } from '../models/user';
import { AppConfig } from '../../app.config';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import { Subject } from 'rxjs/Subject';
@Injectable()
export class AdminDashboardService {


    constructor(
        public http: Http, private config: AppConfig
    ) {
        console.log('Hello TaskProvider Provider');
    }

    public subCloserByPack(reqBody, date) {
        return this.http.post(`${this.config.apiUrl}user/sub-closure-by-pack?date=` + date.toISOString(), reqBody, this.setHeaders())
            .map(res => res.json())
            .toPromise();
    }
    public smsCloserByPack(reqBody, date) {
        return this.http.post(`${this.config.apiUrl}user/sms-closure-by-pack?date=` + date.toISOString(), reqBody, this.setHeaders())
            .map(res => res.json())
            .toPromise();
    }
    public renewalCloserByPack(reqBody, date) {
        return this.http.post(`${this.config.apiUrl}user/renewal-closure-by-pack?date=` + date.toISOString(), reqBody, this.setHeaders())
            .map(res => res.json())
            .toPromise();
    }

    public ePageCloserByPack(reqBody, date) {
        return this.http.post(`${this.config.apiUrl}user/epage-closure-by-pack?date=` + date.toISOString(), reqBody, this.setHeaders())
            .map(res => res.json())
            .toPromise();
    }

    public loyaltyCloserByPack(reqBody, date) {
        return this.http.post(`${this.config.apiUrl}user/loyalty-closure-by-pack?date=` + date.toISOString(), reqBody, this.setHeaders())
            .map(res => res.json())
            .toPromise();
    }
    public pendingPaymentByCity(reqBody, date) {
        return this.http.post(`${this.config.apiUrl}user/pending-payment-by-city?date=` + date.toISOString(), reqBody, this.setHeaders())
            .map(res => res.json())
            .toPromise();
    }

    public pendingDepositionByCity(reqBody, date) {
        return this.http.post(`${this.config.apiUrl}user/pending-deposition-by-city?date=` + date.toISOString(), reqBody, this.setHeaders())
            .map(res => res.json())
            .toPromise();
    }

    public depositionByCity(reqBody, date) {
        return this.http.post(`${this.config.apiUrl}user/deposition-by-city?date=` + date.toISOString(), reqBody, this.setHeaders())
            .map(res => res.json())
            .toPromise();
    }

    public revenueByCity(reqBody, date) {
        return this.http.post(`${this.config.apiUrl}user/revenue-by-city?date=` + date.toISOString(), reqBody, this.setHeaders())
            .map(res => res.json())
            .toPromise();
    }
    public paymentCollectionByCity(reqBody, date) {
        return this.http.post(`${this.config.apiUrl}user/collection-by-city?date=` + date.toISOString(), reqBody, this.setHeaders())
            .map(res => res.json())
            .toPromise();
    }
    private setHeaders(params?: any) {
        // create authorization header with jwt token
        const token = localStorage.getItem('token');
        if (token) {
            // console.log('token >>>' + token);
            const headers = new Headers({ 'x-roamingse-token': token });
            if (params)
                return new RequestOptions({ headers: headers, search: params });
            else
                return new RequestOptions({ headers: headers });
        } else {
            return new RequestOptions({});
        }
    }


}



// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/shared/services/admin-dashboard.service.ts